import { createAsyncThunk } from "@reduxjs/toolkit";

import request from "service";
import { setPracticeWeeks } from "./practiceWeekSlice";
import { IErrorResponse } from "types";
import { IPracticeWeeksCreate, IPracticeWeeksPayload } from "../types";

const GetPracticeWeeks = createAsyncThunk("practiceWeeks/getPracticeWeeks", async (_, { dispatch }) => {
    const response = await request.get("/academic-week");

    dispatch(setPracticeWeeks(response.data.filter((elem: IPracticeWeeksPayload) => elem.kind === "practice")));
    return response.data;
});

const CreatePracticeWeek = createAsyncThunk(
    "create/practiceWeek",
    async (payload: IPracticeWeeksCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/academic-week", payload);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditPracticeWeeks = createAsyncThunk("edit/practiceWeeks", async (data: any, { rejectWithValue }) => {
    try {
        const response = await request.post(`/academic-week`, data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeletePracticeWeeks = createAsyncThunk("delete/practice/weeks", async (id: number, thunkAPI) => {
    try {
        const response = await request.delete(`/academic-week/${id}`);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;

        return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

export { GetPracticeWeeks, CreatePracticeWeek, DeletePracticeWeeks, EditPracticeWeeks };
